var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _g3, _g4, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlassesIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 158,
    viewBox: "0 0 200 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7947 143.452C63.454 144.076 62.6036 144.533 61.0745 144.655C59.5732 144.774 57.574 144.552 55.2005 143.997C50.4615 142.887 44.3579 140.476 38.025 137.017C31.6921 133.558 26.3646 129.726 22.8695 126.339C21.119 124.642 19.8519 123.08 19.1408 121.752C18.4165 120.4 18.342 119.437 18.6827 118.814C19.0234 118.19 19.8738 117.732 21.4028 117.611C22.9041 117.492 24.9034 117.713 27.2768 118.269C32.0158 119.379 38.1194 121.79 44.4524 125.249C50.7853 128.707 56.1127 132.54 59.6078 135.927C61.3583 137.623 62.6254 139.186 63.3366 140.513C64.0608 141.865 64.1353 142.828 63.7947 143.452Z",
    fill: "url(#paint0_linear_343_21371)",
    stroke: "#E3E5E7",
    strokeWidth: 1.11743
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_343_21371)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.0426,
    cy: 130.132,
    rx: 4.54789,
    ry: 2.30755,
    transform: "rotate(21.7976 43.0426 130.132)",
    fill: "#7A7F85"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_343_21371)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.1115,
    cy: 88.302,
    rx: 1.14555,
    ry: 2.32559,
    transform: "rotate(119.286 64.1115 88.302)",
    fill: "#7A7F85",
    fillOpacity: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1573 85.1723C63.7489 84.0891 65.1067 83.6905 66.1899 84.2822C67.2732 84.8738 67.6717 86.2315 67.0801 87.3148L43.5131 130.465C42.9215 131.549 41.5637 131.947 40.4805 131.356C39.3972 130.764 38.9987 129.406 39.5903 128.323L63.1573 85.1723Z",
    fill: "url(#paint1_linear_343_21371)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.001 39.6692L72.5762 24.7449L109.828 45.0901L106.936 65.3112C104.002 85.8213 81.495 97.0969 63.3113 87.1657C45.6881 77.5407 42.5023 53.562 57.001 39.6692Z",
    fill: "url(#paint2_linear_343_21371)",
    fillOpacity: 0.8,
    stroke: "url(#paint3_linear_343_21371)",
    strokeWidth: 1.11743
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.088 45.8693C110.038 45.9618 109.913 46.0833 109.597 46.1722C109.28 46.2614 108.829 46.299 108.236 46.2644C107.053 46.1955 105.436 45.8488 103.485 45.24C99.5927 44.0253 94.484 41.8032 89.09 38.8573C83.6959 35.9113 79.0652 32.8141 75.9393 30.1956C74.3728 28.8834 73.207 27.7103 72.5098 26.7525C72.1603 26.2723 71.9482 25.8726 71.8517 25.5573C71.7556 25.2432 71.7905 25.0729 71.8411 24.9804C71.8916 24.8879 72.016 24.7664 72.3322 24.6775C72.6497 24.5882 73.1006 24.5507 73.6935 24.5852C74.8762 24.6541 76.4933 25.0009 78.444 25.6096C82.3365 26.8244 87.4452 29.0464 92.8393 31.9924C98.2333 34.9384 102.864 38.0356 105.99 40.654C107.556 41.9663 108.722 43.1394 109.419 44.0972C109.769 44.5773 109.981 44.977 110.078 45.2924C110.174 45.6065 110.139 45.7768 110.088 45.8693Z",
    fill: "url(#paint4_linear_343_21371)",
    fillOpacity: 0.8,
    stroke: "#F8F9FA",
    strokeWidth: 1.11743
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.413 57.3848L56.93 56.9435L75.2992 60.6098L91.3486 66.1923L99.2394 69.2287L105.391 71.952C97.8604 89.0513 76.51 95.5355 61.1058 84.9612L59.6802 83.9826C51.0643 78.0682 46.6673 67.6885 48.413 57.3848Z",
    fill: "url(#paint5_linear_343_21371)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.849 71.8159C104.849 71.8321 104.83 71.968 104.491 72.1267C104.17 72.2773 103.664 72.3961 102.963 72.4662C101.567 72.6057 99.5239 72.5413 96.9628 72.2769C91.8489 71.749 84.763 70.4345 76.8712 68.4524C68.98 66.4705 61.8652 64.2055 56.7442 62.1498C54.1797 61.1204 52.1381 60.1525 50.7544 59.3095C50.0591 58.8859 49.5617 58.5128 49.2505 58.2009C48.9207 57.8704 48.914 57.7273 48.9144 57.7156C48.9149 57.7038 48.9323 57.5667 49.281 57.4066C49.6099 57.2555 50.1262 57.137 50.8405 57.0675C52.2618 56.929 54.3379 56.9953 56.9318 57.2614C62.1112 57.7928 69.2624 59.1108 77.1536 61.0927C85.0442 63.0745 92.093 65.3359 97.1478 67.3876C99.6793 68.4151 101.687 69.3808 103.046 70.2215C103.729 70.644 104.215 71.0158 104.52 71.3262C104.84 71.6536 104.85 71.7984 104.849 71.8159Z",
    fill: "#892120",
    stroke: "#892120",
    strokeWidth: 1.11743
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.205 131.907C136.546 132.531 137.396 132.988 138.925 133.11C140.427 133.229 142.426 133.007 144.799 132.451C149.538 131.342 155.642 128.931 161.975 125.472C168.308 122.013 173.635 118.181 177.13 114.794C178.881 113.097 180.148 111.535 180.859 110.207C181.583 108.855 181.658 107.892 181.317 107.269C180.977 106.645 180.126 106.187 178.597 106.066C177.096 105.946 175.097 106.168 172.723 106.724C167.984 107.834 161.881 110.245 155.548 113.703C149.215 117.162 143.887 120.994 140.392 124.382C138.642 126.078 137.375 127.64 136.663 128.968C135.939 130.32 135.865 131.283 136.205 131.907Z",
    fill: "url(#paint6_linear_343_21371)",
    stroke: "#E3E5E7",
    strokeWidth: 1.11743
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_343_21371)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.54789,
    cy: 2.30755,
    rx: 4.54789,
    ry: 2.30755,
    transform: "matrix(-0.928501 0.371329 0.371329 0.928501 160.323 114.756)",
    fill: "#7A7F85"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_343_21371)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.14555,
    cy: 2.32559,
    rx: 1.14555,
    ry: 2.32559,
    transform: "matrix(0.489167 0.87219 0.87219 -0.489167 133.3 76.8955)",
    fill: "#7A7F85",
    fillOpacity: 0.5
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.843 73.6272C136.251 72.5439 134.893 72.1454 133.81 72.737C132.727 73.3286 132.328 74.6864 132.92 75.7696L156.487 118.92C157.079 120.003 158.436 120.402 159.52 119.81C160.603 119.219 161.001 117.861 160.41 116.778L136.843 73.6272Z",
    fill: "url(#paint7_linear_343_21371)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.999 28.1238L127.424 13.1995L90.1724 33.5446L93.0644 53.7657C95.9978 74.2759 118.505 85.5514 136.689 75.6203C154.312 65.9953 157.498 42.0166 142.999 28.1238Z",
    fill: "url(#paint8_linear_343_21371)",
    fillOpacity: 0.8,
    stroke: "url(#paint9_linear_343_21371)",
    strokeWidth: 1.11743
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9118 34.3239C89.9624 34.4164 90.0868 34.5379 90.403 34.6268C90.7204 34.716 91.1714 34.7536 91.7643 34.719C92.947 34.6501 94.564 34.3034 96.5148 33.6946C100.407 32.4799 105.516 30.2578 110.91 27.3119C116.304 24.3659 120.935 21.2687 124.061 18.6502C125.627 17.338 126.793 16.1649 127.49 15.2071C127.84 14.7269 128.052 14.3272 128.148 14.0119C128.244 13.6978 128.209 13.5275 128.159 13.435C128.108 13.3425 127.984 13.221 127.668 13.1321C127.35 13.0428 126.899 13.0053 126.306 13.0398C125.124 13.1087 123.507 13.4555 121.556 14.0642C117.663 15.279 112.555 17.501 107.161 20.447C101.767 23.393 97.136 26.4902 94.0101 29.1086C92.4436 30.4208 91.2778 31.594 90.5806 32.5518C90.2311 33.0319 90.019 33.4316 89.9225 33.747C89.8263 34.0611 89.8613 34.2314 89.9118 34.3239Z",
    fill: "url(#paint10_linear_343_21371)",
    fillOpacity: 0.8,
    stroke: "#F8F9FA",
    strokeWidth: 1.11743
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.587 45.8394L143.07 45.3981L124.701 49.0644L108.651 54.6469L100.761 57.6833L94.6086 60.4066C102.14 77.5059 123.49 83.9901 138.894 73.4158L140.32 72.4372C148.936 66.5228 153.333 56.1431 151.587 45.8394Z",
    fill: "url(#paint11_linear_343_21371)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1508 60.2704C95.1514 60.2867 95.1704 60.4226 95.509 60.5813C95.8303 60.7319 96.3356 60.8507 97.0372 60.9208C98.4333 61.0603 100.476 60.9959 103.037 60.7315C108.151 60.2036 115.237 58.8891 123.129 56.907C131.02 54.9251 138.135 52.6601 143.256 50.6044C145.82 49.5749 147.862 48.6071 149.246 47.7641C149.941 47.3405 150.438 46.9674 150.75 46.6555C151.079 46.325 151.086 46.1819 151.086 46.1701C151.085 46.1584 151.068 46.0213 150.719 45.8612C150.39 45.7101 149.874 45.5916 149.16 45.5221C147.738 45.3836 145.662 45.4499 143.068 45.716C137.889 46.2474 130.738 47.5654 122.846 49.5473C114.956 51.5291 107.907 53.7905 102.852 55.8422C100.321 56.8697 98.3126 57.8354 96.9541 58.6761C96.2715 59.0986 95.7845 59.4704 95.4805 59.7808C95.1597 60.1082 95.1501 60.253 95.1508 60.2704Z",
    fill: "#892120",
    stroke: "#892120",
    strokeWidth: 1.11743
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_343_21371",
    x: 34.2637,
    y: 122.934,
    width: 17.5586,
    height: 14.396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23485,
    result: "effect1_foregroundBlur_343_21371"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_343_21371",
    x: 59.772,
    y: 84.553,
    width: 8.67967,
    height: 7.49803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11743,
    result: "effect1_foregroundBlur_343_21371"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_343_21371",
    x: 148.178,
    y: 111.389,
    width: 17.5586,
    height: 14.396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23485,
    result: "effect1_foregroundBlur_343_21371"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_343_21371",
    x: 131.548,
    y: 73.0081,
    width: 8.67967,
    height: 7.49803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11743,
    result: "effect1_foregroundBlur_343_21371"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_21371",
    x1: 52.2941,
    y1: 136.534,
    x2: 71.116,
    y2: 127.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_21371",
    x1: 40.6912,
    y1: 130.97,
    x2: 65.9792,
    y2: 84.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA5AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA5AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_343_21371",
    x1: 79.5941,
    y1: 53.8356,
    x2: 88.2334,
    y2: 38.0171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_343_21371",
    x1: 62.0506,
    y1: 87.1138,
    x2: 90.572,
    y2: 34.8918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CDD1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF1F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_343_21371",
    x1: 90.4874,
    y1: 33.9075,
    x2: 91.7673,
    y2: 31.5641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_343_21371",
    x1: 78.2375,
    y1: 69.2173,
    x2: 1.79591,
    y2: 94.9491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2120",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_343_21371",
    x1: 147.706,
    y1: 124.989,
    x2: 128.884,
    y2: 116.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_343_21371",
    x1: 159.309,
    y1: 119.425,
    x2: 134.021,
    y2: 73.1228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA5AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA5AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_343_21371",
    x1: 120.406,
    y1: 42.2902,
    x2: 111.767,
    y2: 26.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_343_21371",
    x1: 137.949,
    y1: 75.5684,
    x2: 109.428,
    y2: 23.3464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CDD1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF1F6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_343_21371",
    x1: 109.513,
    y1: 22.3621,
    x2: 108.233,
    y2: 20.0186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_343_21371",
    x1: 121.763,
    y1: 57.6719,
    x2: 198.204,
    y2: 83.4037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F2120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2120",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassesIllustration);
export default __webpack_public_path__ + "static/media/glasses-illustration.6850b8bd612be4f85f6d454f351ea363.svg";
export { ForwardRef as ReactComponent };